import * as Yup from 'yup';
import { sharedSchema } from '../shared/sharedSchema';

const allowedExtensions = ['application/pdf', 'image/jpg', 'image/png', 'image/jpeg'];

export const schema = Yup.object().shape({
    ...sharedSchema,
    prenatalTesting: Yup.string().required('Pole wymagane').nullable(),
    whichPregnancy: Yup.string().required('Pole wymagane').nullable(),
    whichBirth: Yup.string().required('Pole wymagane').nullable(),
    weekOfPregnant: Yup.number('Pole wymagane')
        .typeError('Pole musi być liczbą')
        .max(40, 'Niepoprawna ilość tygodni'),
    indicationsForPrenatalTesting: Yup.string()
        .when('prenatalTesting', {
            is: (value) => {
                return [
                    'KONSULTACJA W POR. GENETYCZNEJ',
                    'BIOPSJA TROFOBLASTU',
                    'AMNIOPUNKCJA',
                ].includes(value);
            },
            then: Yup.string().required('Pole wymagane').nullable(),
        })
        .nullable(),
    importantInformation: Yup.string(),
    uploadedFile: Yup.array()
        .required('Załączenie odpowiedniej dokumentacji jest wymagane.')
        .min(1, 'Załączenie odpowiedniej dokumentacji jest wymagane.')
        .max(5, 'Maksymalnie można załączyć 5 plików')
        .test('size', 'Maksymalny rozmiar pojedynczego pliku to 5MB', (values) =>
            values.every((file) => file.size <= 5 * 1024 * 1024),
        )
        .test('extension', 'Niepoprawny format plików', (values) =>
            values.every((file) => allowedExtensions.includes(file.type)),
        ),
});
